import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhyArissa() {
  const differentiators = ['Technology-driven workflows for faster resolution', 'Personal case ownership by experienced professionals', 'National reach combined with deep local expertise', 'Transparent, actionable reporting and analytics', 'Long-term partnership approach focused on your goals'];
  return <section id="about" className="py-24 bg-brand-paper" data-id="element-333" data-mp="2mact0tlt9x4c">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-334" data-mp="2r8we6rskz4vn">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-335" data-mp="2w0egpka95diq">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-336" data-mp="2w0xwovgcdru4">
            <div className="absolute -inset-4 bg-brand-gold/20 rounded-2xl transform -rotate-3" data-id="element-337" data-mp="1a0f4b2qv9akj"></div>
            <img src="https://cdn.magicpatterns.com/uploads/p3RPSWUkopFwGb81JpD7N9/Depositphotos_group_of_doctors_2.jpg" alt="Diverse team of doctors and nurses smiling together" className="relative rounded-2xl shadow-2xl object-cover h-[600px] w-full" data-id="element-338" data-mp="14z81zj7ht3l9" />

            {/* Overlay Card */}
            <div className="absolute -bottom-8 -right-8 bg-brand-navy p-8 rounded-xl shadow-xl max-w-xs hidden md:block" data-id="element-339" data-mp="1sroi3o7o6lhx">
              <div className="text-brand-gold font-serif text-4xl font-bold mb-2" data-id="element-340" data-mp="1jxa55sam3n1z">
                Commitment
              </div>
              <p className="text-white/90 text-sm leading-relaxed" data-id="element-341" data-mp="1exdw3en255fk">
                Delivering valued care and long-lasting partnerships through
                intelligence and personal connection.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-342" data-mp="2qjcy6l3q0lgw">
            <h2 className="text-brand-gold font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-343" data-mp="2lrbsji125szu">
              Why Choose Us
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-brand-navy mb-6" data-id="element-344" data-mp="27v82m0x7w6t6">
              Built on intelligence and personal connection
            </h3>
            <p className="text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-345" data-mp="1ytiaesvih3uc">
              We understand that behind every claim is a person, and behind
              every program is a bottom line. Our customized programs balance
              compassionate care with rigorous cost containment.
            </p>

            <ul className="space-y-6" data-id="element-346" data-mp="11vuq33f940p">
              {differentiators.map((item, index) => <li key={index} className="flex items-start" data-id="element-347" data-mp="1ll9bsnknpwrt" data-mpi={index}>
                  <CheckCircle2 className="w-6 h-6 text-brand-gold mr-4 flex-shrink-0 mt-0.5" data-id="element-348" data-mp="1hjeedu5uk3jb" />
                  <span className="text-gray-800 font-medium text-lg" data-id="element-349" data-mp="1vasy637kw8rf">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}